import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from '#app/composables/router';
import { useWorkspaceEntityStore } from '#layers/runtime/public';
import { isSpaceRoute } from '#layers/spaces/utils/routes';
import { translateSpace } from '#layers/spaces/utils/space';

export function useCurrentSpace() {
	const i18n = useI18n();
	const store = useWorkspaceEntityStore();
	const route = useRoute();

	const spaceRoute = computed(() => route.matched.find((route) => isSpaceRoute(route)));
	const currentSpaceId = computed(() => spaceRoute.value?.name as string | undefined);

	const { data: currentSpace } = store.MonospaceSpace.query((q) => q.first(currentSpaceId.value
		? {
				key: currentSpaceId.value,
				include: { pages: {}, sections: {} },
			}
		: { enabled: false }));

	const currentSpaceTranslated = computed(() => currentSpace.value ? translateSpace(currentSpace.value, i18n) : null);

	return {
		currentSpace,
		currentSpaceTranslated,
	};
}
